















































































































































import { Component, Vue } from "vue-property-decorator";
import { upsertZhuanbingModule } from "./zhuanbing-content.service";

type RowItem = {
  label: string;
  options: string[];
  suffix?: string;
};

type SectionItem = {
  title: string;
  showHeader: boolean;
  rows: RowItem[];
};

@Component
export default class EditZhuanbingZhenghou extends Vue {
  private form = {
    initials: "",
    name: "",
    cardNo: "",
    doctor: "",
    researcher: "",
    signName: "",
    signYear: "",
    signMonth: "",
    signDay: "",
  };

  private checkedMap: Record<string, string[]> = {};
  private optionInputMap: Record<string, string> = {};
  private scoreMap: Record<string, string> = {};
  private diseaseName: string = "艾滋病免疫重建不全";
  private diseaseKey: string = "aizibing_mianyi_zhongjian_buquan";
  private checkId: string = "";

  private sections: SectionItem[] = [
    {
      title: "一、舌象、脉象（医师填写）",
      showHeader: false,
      rows: [
        { label: "舌色", options: ["淡红", "淡白", "舌红", "舌紫", "舌黯", "其他"] },
        {
          label: "舌形",
          options: ["舌体胖大", "舌有齿痕", "舌有裂纹", "舌有瘀斑", "舌下脉络青紫", "舌体瘦薄"],
        },
        { label: "苔色", options: ["苔白", "苔黄", "苔灰黑"] },
        { label: "苔质", options: ["苔薄", "苔厚", "苔腻", "苔滑", "苔少", "无苔"] },
        { label: "脉象", options: ["沉脉", "细脉", "弱脉", "数脉", "弦脉", "滑脉", "濡脉", "涩脉", "其他"] },
      ],
    },
    {
      title: "二、全身情况",
      showHeader: true,
      rows: [
        { label: "畏寒怕冷", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "手足发冷", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "自汗（白天不活动出汗）", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "盗汗（夜间睡着出汗）", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "五心烦热", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "神疲乏力", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "倦怠乏力", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "气短懒言", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "健忘", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "失眠", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "多梦", options: ["无(0)", "有(1)"] },
        { label: "烦躁/焦虑/抑郁", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      ],
    },
    {
      title: "三、头面五官",
      showHeader: true,
      rows: [
        { label: "头晕", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "头重如裹", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "面色萎黄", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "面色晦暗", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "目干涩/视物不清", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "耳鸣", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "听力下降", options: ["无(0)", "有(1)"] },
        { label: "口唇色淡", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "口唇紫暗", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "口唇干裂", options: ["无(0)", "有(1)"] },
        { label: "口苦", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "口臭", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "口腻", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "口干咽燥", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "口渴欲饮", options: ["无", "轻", "中", "重", "喜热饮", "喜冷饮"] },
      ],
    },
    {
      title: "四、胸腹部",
      showHeader: true,
      rows: [
        { label: "纳差（食欲减退）", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "消谷善饥", options: ["无(0)", "有(1)"] },
        { label: "胃脘痞胀/腹胀", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "腹部坠胀感", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "嗳气/呃逆", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "恶心/厌油", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "胁痛/胁胀", options: ["无(0)", "轻(1)", "中(2)", "重(3)"], suffix: "性质：□隐痛 □胀痛 □刺痛" },
        { label: "腹痛", options: ["无(0)", "轻(1)", "中(2)", "重(3)"], suffix: "部位：□胃脘 □脐周 □小腹" },
      ],
    },
    {
      title: "五、腰背及生殖",
      showHeader: true,
      rows: [
        { label: "腰膝酸软", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "腰痛（冷痛/酸痛）", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "夜尿频多（≥2次/晚）", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "性欲减退/阳痿", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "女性：月经异常/带下", options: ["无", "有（具体：________）"] },
      ],
    },
    {
      title: "六、肢体与皮肤",
      showHeader: true,
      rows: [
        { label: "肢体困重", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "肢体麻木", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "爪甲不荣", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "皮肤瘙痒", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "皮肤斑丘疹", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "皮肤瘀点/瘀斑", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "蜘蛛痣/肝掌", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      ],
    },
    {
      title: "七、二便",
      showHeader: true,
      rows: [
        { label: "大便稀溏/泄泻", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "大便黏腻不爽", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "大便干结", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "小便色黄", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
        { label: "小便不畅/余沥", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      ],
    },
  ];

  private bleedOptions = ["无", "鼻衄", "齿衄", "皮下瘀斑", "其他________"];
  private diagnosisOptions = [
    "脾肾阳虚证",
    "气阴两虚证",
    "湿热内蕴证",
    "瘀血阻络证",
    "肺脾气虚证",
    "复合证型（请注明：____________）",
  ];

  private mounted() {
    const fromQuery = this.$route.query.disease as string;
    if (fromQuery) {
      this.diseaseName = fromQuery;
    }
    const queryKey = this.$route.query.diseaseKey as string;
    if (queryKey) {
      this.diseaseKey = queryKey;
    }
    const queryCheckId = this.$route.query.checkId as string;
    if (queryCheckId) {
      this.checkId = queryCheckId;
    }
    this.fillFormByPatient();
  }

  private get patient() {
    return this.$store.state.patient;
  }

  private fillFormByPatient(source?: any) {
    const p: any = source || this.patient || {};
    if (!this.form.name) {
      this.form.name = p.name || "";
    }
    if (!this.form.cardNo) {
      this.form.cardNo =
        p.outpatient_card_no ||
        p.outpatientNo ||
        p.clinic_card_no ||
        p.card_no ||
        p.medical_card_no ||
        p.uid ||
        "";
    }
    const candidateInitials =
      p.pym ||
      p.py ||
      p.name_py ||
      p.namePinyin ||
      p.name_pinyin ||
      p.name_initials ||
      p.initials ||
      "";
    const computedInitials = this.buildNameInitials(this.form.name);
    if (!this.form.initials) {
      this.form.initials = candidateInitials || computedInitials;
      return;
    }
    if (this.shouldAutoFixInitials(this.form.initials, this.form.name) && computedInitials) {
      this.form.initials = computedInitials;
    }
  }

  private shouldAutoFixInitials(initials: string, name: string) {
    const value = String(initials || "").trim().toUpperCase();
    const onlyChinese = String(name || "").replace(/[^\u4e00-\u9fa5]/g, "");
    if (!value || !onlyChinese) {
      return false;
    }
    if (/^(Z)+$/.test(value) || /^(X)+$/.test(value)) {
      return true;
    }
    return false;
  }

  private buildNameInitials(name: string) {
    const value = String(name || "").trim();
    if (!value) {
      return "";
    }
    const englishTokens = value
      .replace(/[^A-Za-z\s]/g, " ")
      .split(/\s+/)
      .filter(Boolean);
    if (englishTokens.length > 0) {
      return englishTokens
        .map((token) => token.charAt(0).toUpperCase())
        .join("")
        .slice(0, 4);
    }
    const chinese = value.replace(/[^\u4e00-\u9fa5]/g, "");
    if (!chinese) {
      return "";
    }
    return chinese
      .split("")
      .map((ch) => this.getChineseInitial(ch))
      .join("")
      .slice(0, 4)
      .toUpperCase();
  }

  private getChineseInitial(ch: string) {
    // 基于中文拼音排序规则的前端首字母映射（无需后端/拼音库）
    const map = [
      { start: "阿", initial: "A" },
      { start: "芭", initial: "B" },
      { start: "擦", initial: "C" },
      { start: "搭", initial: "D" },
      { start: "蛾", initial: "E" },
      { start: "发", initial: "F" },
      { start: "噶", initial: "G" },
      { start: "哈", initial: "H" },
      { start: "击", initial: "J" },
      { start: "喀", initial: "K" },
      { start: "垃", initial: "L" },
      { start: "妈", initial: "M" },
      { start: "拿", initial: "N" },
      { start: "哦", initial: "O" },
      { start: "啪", initial: "P" },
      { start: "期", initial: "Q" },
      { start: "然", initial: "R" },
      { start: "撒", initial: "S" },
      { start: "塌", initial: "T" },
      { start: "挖", initial: "W" },
      { start: "昔", initial: "X" },
      { start: "压", initial: "Y" },
      { start: "匝", initial: "Z" },
    ];
    for (let i = map.length - 1; i >= 0; i -= 1) {
      if (this.compareZhByPinyin(ch, map[i].start) >= 0) {
        return map[i].initial;
      }
    }
    return "X";
  }

  private compareZhByPinyin(a: string, b: string) {
    try {
      return a.localeCompare(b, "zh-Hans-u-co-pinyin");
    } catch (e) {
      return a.localeCompare(b, "zh");
    }
  }

  private async saveDraft(showMessage: boolean = true) {
    const payload = {
      form: this.form,
      checkedMap: this.checkedMap,
      optionInputMap: this.optionInputMap,
      scoreMap: this.scoreMap,
      savedAt: Date.now(),
    };
    try {
      await upsertZhuanbingModule(this, {
        patientId: this.patient.id,
        diseaseName: this.diseaseName,
        diseaseKey: this.diseaseKey,
        checkId: this.checkId,
        moduleKey: "zhenghou",
        moduleData: payload,
        loadingText: "保存专病证候量表…",
      });
      if (showMessage) {
        this.$message.success("保存成功");
      }
    } catch (e: any) {
      const msg = e?.message || "保存失败，请稍后重试";
      this.$message.error(msg);
      throw e;
    }
  }

  private async printPage() {
    await this.saveDraft(false);
    this.$nextTick(() => {
      window.print();
    });
  }

  private goBack() {
    this.$router.back();
  }

  private isSelected(key: string, opt: string) {
    return (this.checkedMap[key] || []).includes(opt);
  }

  private toggleChoice(key: string, opt: string) {
    const current = this.checkedMap[key] || [];
    if (current.includes(opt)) {
      this.$set(
        this.checkedMap,
        key,
        current.filter((v) => v !== opt)
      );
      return;
    }
    this.$set(this.checkedMap, key, [...current, opt]);
  }

  private hasOptionInput(opt: string) {
    return opt.includes("___");
  }

  private getOptionTextPrefix(opt: string) {
    if (!this.hasOptionInput(opt)) return opt;
    return opt.split(/_{2,}/)[0];
  }

  private getOptionTextSuffix(opt: string) {
    if (!this.hasOptionInput(opt)) return "";
    const parts = opt.split(/_{2,}/);
    return parts.slice(1).join("");
  }

  private getOptionInputKey(groupKey: string, opt: string) {
    return `${groupKey}__${opt}`;
  }

  private getOptionInputValue(groupKey: string, opt: string) {
    const key = this.getOptionInputKey(groupKey, opt);
    return this.optionInputMap[key] || "";
  }

  private setOptionInputValue(groupKey: string, opt: string, value: string) {
    const key = this.getOptionInputKey(groupKey, opt);
    this.$set(this.optionInputMap, key, value);
  }

  private onOptionInput(groupKey: string, opt: string, e: Event) {
    const target = e.target as HTMLInputElement | null;
    this.setOptionInputValue(groupKey, opt, target ? target.value : "");
  }

  private getScoreKey(sectionTitle: string, rowIndex: number) {
    return `${sectionTitle}__${rowIndex}`;
  }

  private getScoreValue(sectionTitle: string, rowIndex: number) {
    return this.scoreMap[this.getScoreKey(sectionTitle, rowIndex)] || "";
  }

  private onScoreInput(sectionTitle: string, rowIndex: number, e: Event) {
    const target = e.target as HTMLInputElement | null;
    const value = target ? target.value : "";
    this.$set(this.scoreMap, this.getScoreKey(sectionTitle, rowIndex), value);
  }
}
